import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MediaGallery.css";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import "yet-another-react-lightbox/styles.css";
// import video from "../../Assets/Images/Test.mp4";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

const MediaGallery = (props) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  console.log(props.images);
  const shouldAnimate = props.animation && props.animation.animationType && props.animation.animationType !== 'none';

  // Utility function to check for video file extensions
  const isVideoFile = (filePath) => {
    return /\.(mp4|mov|webm|avi|mkv|m4v|ogg|wmv)$/i.test(filePath);
  };

  // Utility function to check for image file extensions
  const isImageFile = (filePath) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp|svg|heic|heif|tiff|tif)$/i.test(filePath);
  };

  // Classify each media item as image, video, or embed (iframe)
  const mediaItems = (props.images || []).map((url) => {
    if (isVideoFile(url)) return { type: 'video', url };
    if (isImageFile(url)) return { type: 'image', url };
    return { type: 'embed', url };
  });

  // Build Lightbox slides only for image and video types
  const slides = mediaItems
    .filter((item) => item.type !== 'embed')
    .map((item) => {
      if (item.type === 'video') {
        const ext = item.url.split('.').pop().toLowerCase();
        let mime = 'video/mp4';
        if (ext === 'webm') mime = 'video/webm';
        else if (ext === 'ogg') mime = 'video/ogg';
        else if (ext === 'mov') mime = 'video/quicktime';
        else if (ext === 'avi') mime = 'video/x-msvideo';
        else if (ext === 'mkv') mime = 'video/x-matroska';
        else if (ext === 'm4v') mime = 'video/x-m4v';
        else if (ext === 'wmv') mime = 'video/x-ms-wmv';
        return {
          type: 'video',
          sources: [{ src: item.url, type: mime }],
          title: 'Video Slide',
          description: 'Video description'
        };
      }
      return {
        src: item.url,
        title: 'Image Slide',
        description: 'Image description'
      };
    });

  return (
    <div className="container" {...(shouldAnimate ? {
      'data-aos': props.animation.animationType,
      'data-aos-duration': Number(props.animation.animationDuration),
      'data-aos-delay': Number(props.animation.animationDelay),
    } : {})}>
      {isViewerOpen && (
        <Lightbox
          open={isViewerOpen}
          close={() => setIsViewerOpen(false)}
          index={selectedIndex}
          slides={slides}
          carousel={false}
          plugins={[Video,Fullscreen,Captions,Slideshow,Zoom]}
          on={{ click: () => setIsViewerOpen(false) }}
        />
      )}

      <h2 className="text-center mb-4">{props.title || 'Media Gallery'}</h2>
      <div className="row CenterRow">
        {mediaItems.map((item, itemIdx) => {
          if (item.type === 'embed') {
            return (
              <div key={itemIdx} className="col-lg-3 col-md-4 col-sm-6 col-6 col-6 GalleryItemCol mb-1 p-1">
                <div className="gallery-item">
                  <iframe
                    src={item.url}
                    className="img-fluid"
                    style={{ aspectRatio: '16/9', width: '100%', border: 'none' }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                    title={`embedded-media-${itemIdx}`}
                  />
                </div>
              </div>
            );
          }

          // Map item index to slides index for lightbox
          const slideIndex = slides.findIndex((s) => {
            return (item.type === 'video' && s.type === 'video' && s.sources[0].src === item.url) ||
                   (item.type === 'image' && !s.type && s.src === item.url);
          });

          return (
            <div key={itemIdx} className="col-lg-3 col-md-4 col-sm-6 col-6 col-6 GalleryItemCol mb-1 p-1">
              <div className="gallery-item">
                {item.type === 'video' ? (
                  <video
                    src={item.url}
                    className="img-fluid"
                    onClick={() => {
                      if (slideIndex >= 0) {
                        setSelectedIndex(slideIndex);
                        setIsViewerOpen(true);
                      }
                    }}
                    style={{ cursor: 'pointer' }}
                    controls={false}
                  />
                ) : (
                  <img
                    src={item.url}
                    className="img-fluid"
                    onClick={() => {
                      if (slideIndex >= 0) {
                        setSelectedIndex(slideIndex);
                        setIsViewerOpen(true);
                      }
                    }}
                    alt={`Gallery ${itemIdx}`}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MediaGallery;
